import { Table } from "@chakra-ui/react";
import GenericTable from "../../../../../components/GenericTable";
import GenericTableElement from "../../../../../components/GenericTableElement";
import { SETTLEMENT_ADJUSTMENTS_TABLE_COLUMNS } from "../../../../../config/tables";
import { Adjustment } from "../../../../../types/types";

type Props = {
  adjustments: Adjustment[];
  isLoading: boolean;
};

const AdjustmentsTable = ({ adjustments, isLoading }: Props): JSX.Element => {
  return (
    <GenericTable
      interactive
      isLoading={isLoading}
      columns={SETTLEMENT_ADJUSTMENTS_TABLE_COLUMNS}
    >
      {adjustments.map((item: Adjustment, index: number) => (
        <Table.Row key={index}>
          {SETTLEMENT_ADJUSTMENTS_TABLE_COLUMNS.map((column) => {
            return (
              <GenericTableElement
                key={`${index}-${column.key}`}
                formatDatetimeUtc={
                  "format" in column && column.format === "datetime"
                }
                value={item[column.key]}
                formatNumber={
                  "format" in column && column.format === "currency"
                }
              />
            );
          })}
        </Table.Row>
      ))}
    </GenericTable>
  );
};

export default AdjustmentsTable;
